<template>
  <div class="ContractorSelect">
    <a-select
      v-model="externalId"
      :disabled="isDisabled"
      allow-clear
      @change="change"
      @blur="blur"
      @focus="focus"
      @popupScroll="popupScroll"
    >
      <!-- <a-select-option v-for="item in exhibitionNameList" :key="item.userId" :value="item.userId" :label="item.userName" /> -->
      <a-select-option
        v-for="item in exhibitionNameList"
        :key="item.userId"
        :value="item.userId"
      >
        {{ item.userName }}
      </a-select-option>
    </a-select>
  </div>
</template>

<script>
export default {
  name: 'ContractorSelect',
  components: {},
  props: {
    value: { // 用于双向绑定
      type: [Number, String],
      default: () => ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    dynamicExhibitionId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      exhibitionNameList: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      done: false, // 标识 当前page返回的total === 当前Options
      optionLoading: false
    }
  },
  computed: {
    externalId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        // if (!val || val.length === 0) {
        //   this.clear()
        // }
      }
    }
  },
  watch: {
    dynamicExhibitionId() {
      this.init()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.done = false
      this.page.pageNum = 1
      this.getOptions()
    },
    getOptions() {
      if (this.done) return
      const exhibitionId = this.dynamicExhibitionId || sessionStorage.getItem('exhibitionId')
      const { pageNum, pageSize } = this.page
      this.$http.get(`${this.api}a/api/exhibition/contractor/${exhibitionId}?pageNum=${pageNum}&pageSize=${pageSize}`).then(res => {
        const { list, pageNum } = res.data
        // if (this.exhibitionNameList.length === total) {
        //   this.done = true
        // } else {
        //   if (this.dynamicExhibitionId) {
        //     this.exhibitionNameList = [...list]
        //   } else {
        //     this.exhibitionNameList = [...this.exhibitionNameList, ...list]
        //   }
        //   this.pageNum = pageNum
        // }
        if (this.dynamicExhibitionId) {
          this.exhibitionNameList = [...list]
        } else {
          this.exhibitionNameList = [...this.exhibitionNameList, ...list]
        }
        this.pageNum = pageNum
      })
    },
    change(event) {
      this.$emit('change', event, this.exhibitionNameList)
    },
    popupScroll() {
      if (this.optionLoading || this.done) { // 正在加载中 或 已经达到最大请求数时 直接返回
        return
      }
      this.optionLoading = true
      this.page.pageNum++
      this.getOptions()
    },
    // clear() {
    //   this.reset()
    //   this.$emit('clear')
    // },
    // reset() { // 重置当前组件数据
    //   this.done = false
    //   this.page.pageNum = 1
    //   this.exhibitionNameList = []
    // },
    blur(e) {
      this.$emit('blur', e)
    },
    focus(e) {
      this.$emit('focus', e)
    }
  }
}
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/component/base/ContractorSelect.vue